import { BaseComponent2 } from '../../_common/client/base-component2';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class OnpageSearchComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_onpage-search';
    private isOpen = false;

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        this.listenToOnpageSearch();
    }

    private listenToOnpageSearch() {
        document.addEventListener('keydown', e => {
            if (this.isOpen) return;
            if (e.key === 'f' && (e.ctrlKey || e.metaKey)) {
                trackEvent({
                    product_OnpageSearch: ['open'],
                });
                this.isOpen = true;
            }
        });
    }
}
